/** @format */

import {If, AdaptiveImage} from 'frontier-utilities';
import NumberFormat from 'react-number-format';
import React from 'react';

export const DesignsUpdated = props => {
    const {uploadedDesigns} = props;

    return (
        <div>
            <div className="d-flex align-items-center justify-content-start gap-3 mb-4 mx-0 ">
                <i className="color-accent-primary fa fa-check-circle" style={{fontSize: '32px'}} />
                <p className="m-0 color-accent-primary" style={{fontSize: '18px'}}>
                    Designs updated
                </p>
            </div>
            {uploadedDesigns.map(dos => {
                return (
                    <div key={dos.id} style={{marginTop: '30px'}}>
                        <div>
                            <p className="bg-structure-lightest p-3 mt-0 mb-2 mx-0">
                                <b>Design Qty: </b>
                                <NumberFormat
                                    value={dos.qty}
                                    thousandSeparator={true}
                                    displayType="text"
                                />
                            </p>
                            <If condition={dos.design.customer_version_count > 0}>
                                <p className="bg-structure-lightest p-3 mt-0 mb-2 mx-0">
                                    <b className="badge text-bg-secondary">Version: </b>
                                    {dos.design.customer_version_count + 1}
                                </p>
                            </If>
                            <p className="bg-structure-lightest p-3 mt-0 mb-2 mx-0">
                                <b>Filename: </b>
                                {dos.filename}
                            </p>
                        </div>
                        <AdaptiveImage src={dos.signed_url} style={{width: '100%'}} isMaxWidth />
                    </div>
                );
            })}
        </div>
    );
};
